import { render, staticRenderFns } from "./DashboardStat.vue?vue&type=template&id=ae007580&scoped=true"
import script from "./DashboardStat.vue?vue&type=script&lang=ts"
export * from "./DashboardStat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae007580",
  null
  
)

export default component.exports